/**
 * The words for an AI risk factor. The backend sends a free-form key ("low_quiz_scores",
 * "LOW_ENGAGEMENT"): it is normalised and looked up in `student360.risk.factor.*`, so a Uzbek or
 * Russian screen never shows an English sentence. A key the dictionary does not know reads as the
 * generic "Other factor"; the raw key stays available as the tooltip so staff can still see what it was.
 */
const KNOWN = new Set([
  'low_engagement', 'missed_deadlines', 'low_quiz_scores', 'low_exam_scores', 'inactivity',
  'no_recent_activity', 'slow_progress', 'low_completion', 'failed_assignments',
  'declining_performance', 'irregular_study',
]);

export function normalizeRiskFactor(factor) {
  return String(factor || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
}

/** { label, hint } of a risk factor key: the translated label, and the raw key when it was not known. */
export function riskFactorText(t, factor) {
  const key = normalizeRiskFactor(factor);
  if (!key) return { label: '', hint: '' };
  if (KNOWN.has(key)) return { label: t(`student360.risk.factor.${key}`), hint: '' };
  return { label: t('student360.risk.factor.other'), hint: key.replace(/_/g, ' ') };
}
